<template>

    <!-- login component  Modal -->
    <div class="modal fade" v-show="dialog" id="loginModal" :aria-hidden="!dialog" :aria-modal="dialog ? 'true' : null" :inert="!dialog ? '' : null" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">

            <button type="button" class="close-model-btn" data-bs-dismiss="modal" aria-label="Close" @click="$emit('close')">
                <i class="fa-regular fa-circle-xmark"></i>
            </button>

            <div class="content-model-me">

                <div class="modal-header">
                  <h2 class="section-title"> {{ $t('auth.login') }}  </h2>
                </div>

                <!-- form  -->
                <form action="add-ads.html" class="modal-form" ref="loginForm">
                    <div class="modal-body">

                        <!-- Login Method Toggle -->
                        <div class="login-method-toggle d-flex justify-content-center mb-4">
                            <button type="button" 
                                    class="toggle-btn" 
                                    :class="{ active: loginMethod === 'phone' }"
                                    @click="loginMethod = 'phone'; phone_or_email = ''">
                                رقم الجوال
                            </button>
                            <button type="button" 
                                    class="toggle-btn" 
                                    :class="{ active: loginMethod === 'email' }"
                                    @click="loginMethod = 'email'; phone_or_email = ''">
                                البريد الإلكتروني
                            </button>
                        </div>

                        <div class="inputs-container">
                            <div class="input-g">
                                <label for="login_phone_or_email" class="main-label">
                                    {{ loginMethod === 'phone' ? 'رقم الجوال' : 'البريد الإلكتروني' }}
                                    <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span>
                                </label>
                                <div class="main-input phone-input-group">
                                    <select v-if="loginMethod === 'phone'" class="country-code-select" v-model="phoneCountryCode" aria-label="كود الدولة">
                                      <option v-for="c in countryCodes" :key="c.code" :value="c.code">{{ formatCodeLabel(c) }}</option>
                                    </select>
                                    <input type="text"  class="input-me" id="login_phone_or_email" autocomplete="username" :class="{ error : v$.phone_or_email.$error, 'email-mode': loginMethod === 'email' }" :placeholder="loginMethod === 'phone' ? $t('auth.phonePlace') : 'أدخل البريد الإلكتروني'" name="phone_or_email" v-model="phone_or_email" @input="phone_or_email = convertDigits($event.target.value)">
                                </div>
                                <span class="error" v-if="v$.phone_or_email.$error"> 
                                    <template v-if="!v$.phone_or_email.required.$response">{{ $t('validation.required') }}</template>
                                    <template v-else-if="loginMethod === 'email' && !v$.phone_or_email.email.$response">يرجى إدخال بريد إلكتروني صحيح</template>
                                    <template v-else-if="loginMethod === 'phone' && !v$.phone_or_email.validPhone.$response">يجب أن يدخل الرقم بشكل صحيح</template>
                                </span>
                            </div>

                            <div class="input-g">
                                <label for="login_password" class="main-label">
                                    كلمة المرور <span style="font-size: 11px; color: #888;">(يرجي الكتابه باللغه الانجليزية)</span>
                                </label>
                                <div class="main-input">
                                    <span class="pass-icon main-icon" @click="switchVisibility()">

                                        <font-awesome-icon icon="fa-solid fa-eye-slash" v-if="!eyeToggle"/>

                                        <font-awesome-icon icon="fa-solid fa-eye" v-else-if="eyeToggle" />
                                    </span>
                                    <input :type="passwordFieldType" class="input-me" id="login_password" autocomplete="current-password" :class="{ error : v$.password.$error}" :placeholder="$t('auth.passwordPlace')" name="password" v-model="password" @input="password = convertDigits($event.target.value)">


                                </div>
                                <span class="error" v-if="v$.password.$error"> {{ $t('validation.required')}} </span>

                            </div>
                        </div>

                        <div class="anchor text-center">
                            <a href="#" data-bs-toggle="modal" data-bs-target="#sendModal" class="forget-anchor"> {{ $t('auth.forgetPass') }} </a>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button class="main-btn md up" type="submit"  @click.prevent="login()" :disabled="disabled || loginFrozen" :title="loginFrozen ? 'تم إيقاف تسجيل الدخول مؤقتاً' : ''"> 
                            {{  $t('auth.login') }} 
                            <div class="spinner-border" role="status" v-if="disabled">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </button>
                    </div>

                    <div class="reg text-center">
                        <a href="#" class="reg-anchor" data-bs-toggle="modal" data-bs-target="#regModal" data-bs-dismiss="modal" aria-label="Close">
                            إنشاء حساب مستخدم جديد
                        </a>
                    </div>
                </form>

            </div>
          </div>
        </div>
    </div>


    <!-- forget pass modal  -->
    <forgetPass />

    <!-- activation code / -->
    <activatioCode />

    <!-- register  -->
    <registerComponent :dataDialog="dataDialog"  />
</template>

<script>

import axios from 'axios'
import { Modal } from 'bootstrap'
import { mapState , mapGetters , mapMutations } from 'vuex'
import { setAuthToken } from '../../utils/defaults'

import forgetPass from './forgetPassword.vue'
import activatioCode from './activationCode.vue'
import registerComponent from './regiesterComponent.vue'

import useValidate from "@vuelidate/core"
import { required, email, helpers } from "@vuelidate/validators"

const validPhone = helpers.regex(/^(\+)?\d{8,15}$/);

export default {
    data(){
        return{
            v$ : useValidate(),
            loginMethod: 'phone', // 'phone' or 'email'
            phone_or_email : '',
            password : '',
            device_type : "web",
            disabled : false,
            loginFrozen: false,
            dataDialog : false,
            phoneCountryCode: '+966',
            countryCodes: [
              { name: 'السعودية', code: '+966' },
            ]
        }
    },

    validations(){
        if(this.loginMethod === 'email'){
            return{
                phone_or_email : { required, email },
                password : { required }
            }
        }
        return{
            phone_or_email : { required, validPhone },
            password : { required }
        }
    },

    computed : {
        ...mapState(["eyeToggle"]),
        ...mapGetters(["eyeToggle"]),
        ...mapState(["passwordFieldType"]),
        ...mapGetters(["passwordFieldType"])
    },
    components:{
        forgetPass,
        activatioCode,
        registerComponent
    },
    methods : {
        convertDigits(value) {
            if (!value) return value;
            const map = {
                '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
                '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
            };
            return value.replace(/[٠-٩]/g, function(d) { return map[d]; });
        },
        formatCodeLabel(c){
            const code = String(c.code || '').replace('+','');
            return `+${code}`;
        },
        normalizeLocalPhone(value){
            const raw = String(value || '').replace(/\s+/g,'');
            const digits = raw.replace(/[^\d+]/g,'');
            let v = digits.startsWith('+') ? digits.slice(1) : digits;
            v = v.replace(/^0+/, '');
            const code = String(this.phoneCountryCode || '').replace(/[^\d]/g,'');
            if (code && v.startsWith(code)) v = v.slice(code.length);
            v = v.replace(/^0+/, '');
            return v;
        },
        
        // login function 
        async login(){
            
            // Check maintenance/login status first
            const loginDisabled = localStorage.getItem('login_disabled') === 'true';
            const maintenanceEnabled = localStorage.getItem('maintenance_enabled') === 'true';
            
            if (loginDisabled || maintenanceEnabled) {
                this.$swal({
                    icon: 'error',
                    title: 'تسجيل الدخول متوقف',
                    text: 'نعتذر، تم إيقاف تسجيل الدخول مؤقتاً من قبل الإدارة',
                    timer: 3000,
                    showConfirmButton: false,
                });
                this.loginFrozen = true;
                return;
            }

            this.disabled = true

            await this.v$.$validate()
            const phone = (this.phone_or_email || '').trim();
            const pass = this.password || '';
            const basicValid = phone.length > 0 && pass.length > 0;

            if (!basicValid) {
                this.v$.$touch();
                const missing = [];
                if (!phone) missing.push('الهاتف/البريد');
                if (!pass) missing.push('كلمة المرور');
                this.$swal({
                    icon: 'error',
                    title: 'يرجى تعبئة الحقول المطلوبة',
                    text: missing.length ? `الحقول الناقصة: ${missing.join('، ')}` : '',
                    timer: 2000,
                    showConfirmButton: false,
                });
                this.disabled = false;
                return;
            }

            const payload = new URLSearchParams();
            const rawInput = (this.phone_or_email || '').trim();
            let formatted = rawInput;
            if (this.loginMethod === 'phone' && rawInput) {
              formatted = this.normalizeLocalPhone(rawInput);
            }
            payload.append('phone_or_email', formatted);
            payload.append('password', this.password || '');
            payload.append('device_id', sessionStorage.getItem('device_id') || 'web');
            payload.append('device_type', this.device_type);

            const closeModalSafely = () => {
                try { this.$emit('close'); } catch(_) { void 0; }
                try {
                    const modalEl = document.getElementById('loginModal');
                    if (modalEl) {
                        const instance = Modal.getInstance(modalEl) || Modal.getOrCreateInstance(modalEl);
                        instance.hide();
                    }
                } catch (_) { void 0; }
                try {
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
                } catch (_) { void 0; }
                try { document.body.classList.remove('modal-open'); } catch(_) { void 0; }
            };

            try {
                const res = await axios.post('sign-in', payload);
                const key = res?.data?.key;

                if (key === "success") {
                    const token = res?.data?.data?.token;
                    if (token) {
                        setAuthToken(token, axios, 'login');
                    }
                    localStorage.setItem('IsActivated', 'true');

                    this.$swal({
                        icon: 'success',
                        title: res.data.msg,
                        timer: 2000,
                        showConfirmButton: false,
                    });

                    closeModalSafely();
                    location.reload();
                    return;
                }

                if (key === "needActive") {
                    if (process.env.NODE_ENV !== 'production') {
                        setAuthToken('DEV_FAKE_TOKEN_123', axios, 'login-dev');
                        localStorage.setItem('IsActivated', 'true');
                        this.$swal({
                            icon: 'success',
                            title: 'تم تفعيل الحساب (وضع تطوير)',
                            timer: 1500,
                            showConfirmButton: false,
                        });
                        closeModalSafely();
                        location.reload();
                        return;
                    }

                    this.$swal({
                        icon: 'error',
                        title: res?.data?.msg || 'يتطلب تفعيل الحساب',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    closeModalSafely();
                    setTimeout(() => {
                        this.dataDialog = true
                    }, 2000);
                    return;
                }

                this.$swal({
                    icon: 'error',
                    title: res?.data?.msg || 'فشل تسجيل الدخول',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    setAuthToken('DEV_FAKE_TOKEN_123', axios, 'login-dev');
                    localStorage.setItem('IsActivated', 'true');
                    this.$swal({
                        icon: 'success',
                        title: 'تم تسجيل الدخول (وضع تطوير)',
                        timer: 1500,
                        showConfirmButton: false,
                    });
                    closeModalSafely();
                    location.reload();
                    return;
                }

                this.$swal({
                    icon: 'error',
                    title: 'فشل تسجيل الدخول',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } finally {
                this.disabled = false;
            }
        },

        // show password function 
        ...mapMutations(["switchVisibility"])
    },


    mounted(){
            // مزامنة حالة تجميد تسجيل الدخول من التخزين المحلي
            const syncFrozen = () => {
                const loginDisabled = localStorage.getItem('login_disabled') === 'true';
                const maintenanceEnabled = localStorage.getItem('maintenance_enabled') === 'true';
                this.loginFrozen = loginDisabled || maintenanceEnabled;
            };
            this._syncFrozen = syncFrozen;
            this._syncFrozen();
            this._frozenInterval = setInterval(this._syncFrozen, 2000);
            window.addEventListener('storage', this._syncFrozen);

            // الحصول على معرف الجهاز في بيئة الإنتاج فقط
            if (process.env.NODE_ENV === 'production') {
                try {
                    fetch('https://api.ipify.org?format=json')
                        .then((response) => response.json())
                        .then((data) => {
                            if (data && data.ip) {
                                sessionStorage.setItem('device_id', data.ip);
                            } else {
                                sessionStorage.setItem('device_id', 'web');
                            }
                        })
                        .catch(() => sessionStorage.setItem('device_id', 'web'));
                } catch(_) {
                    sessionStorage.setItem('device_id', 'web');
                }
            } else {
                sessionStorage.setItem('device_id', 'web');
            }


            this.dataDialog = this.dialog
            const el = this.$el;
            if (el && el.addEventListener) {
                this._loginModalHandler = () => this.$emit('close');
                el.addEventListener('hidden.bs.modal', this._loginModalHandler);
            }
    },
    beforeUnmount(){
        const el = this.$el;
        if (el && this._loginModalHandler) {
            el.removeEventListener('hidden.bs.modal', this._loginModalHandler);
        }
        if (this._frozenInterval) {
            clearInterval(this._frozenInterval);
            this._frozenInterval = null;
        }
        if (this._syncFrozen) {
            window.removeEventListener('storage', this._syncFrozen);
        }
    },
    emits: ['close'],
    props:{
        dialog : Boolean
    }
}
</script>

<style scoped>
    a{
        color: #333 !important;
    }
    .phone-input-group{ display: flex; align-items: center; gap: 8px; direction: ltr; text-align: left; }
    .phone-input-group .country-code-select{
      position: static;
      transform: none;
      height: 40px;
      padding: 2px 8px;
      border: 1px solid #ddd;
      border-radius: 6px;
      background: #fff;
      color: #333;
      font-size: 12px;
      direction: ltr;
      unicode-bidi: plaintext;
      flex: 0 0 auto;
    }
    .phone-input-group .input-me{ padding-left: 12px !important; direction: ltr; text-align: left; unicode-bidi: plaintext; flex: 1 1 auto; min-width: 0; }
    .phone-input-group .input-me.email-mode{ padding-left: 12px; }
    
    .login-method-toggle {
        background: #f8f9fa;
        padding: 4px;
        border-radius: 8px;
        gap: 8px;
    }
    .toggle-btn {
        flex: 1;
        padding: 8px 16px;
        border: none;
        background: transparent;
        color: #666;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        transition: all 0.3s ease;
    }
    .toggle-btn.active {
        background: #fff;
        color: #2ABDC7; /* Main brand color */
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .reg-anchor {
        color: #1d7af3 !important;
        text-decoration: underline !important;
        font-weight: bold;
        font-size: 15px;
    }
</style>
<style >
    .error{
        color:red;
        font-size:12px;
        transition:.3s all;
    }
    .error.errorShow{
        transform: translateX(-10px);
    }
</style>
